// This file is automatically generated. Do not edit manually.

import { IsoDateTimeString } from "src/types/dateTime";
import { ControlChartStatisticsSource } from "src/api/generated/spc/controlChart/analysis/controlChartStatisticsSource";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ControlChartStatisticsApi {
	export async function getStatistics(args: {
		controlChartId: number;
		sampleSize: number;
		beforeDate: IsoDateTimeString | null | undefined;
	}): Promise<ControlChartStatisticsApi_StatisticsResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartStatistics/getStatistics",
			method: "POST",
			data: {
				controlChartId: args.controlChartId,
				sampleSize: args.sampleSize,
				beforeDate: args.beforeDate,
			},
		});
		return response as ControlChartStatisticsApi_StatisticsResult;
	}
}

export interface ControlChartStatisticsApi_StatisticsResult {
	source: ControlChartStatisticsSource;
	withinStandardDeviation: number | null | undefined;
}
